import { useHookstate } from "@hookstate/core";
import { useReleaseData } from "./hookstate/useReleaseData";
import { readerSettingsStore } from "../../../hookstate/readerSettingsStore";

export function useNSFWInterstitial() {
  const { releaseData } = useReleaseData();

  const showNSFWInterstitial = useHookstate(
    readerSettingsStore.showNSFWInterstitial,
  ).get();

  const disableNSFWInterstitial = () => {
    readerSettingsStore.showNSFWInterstitial.set(false);
  };

  return {
    showNSFWInterstitial:
      (showNSFWInterstitial ?? true) && releaseData?.is_nsfw,
    disableNSFWInterstitial,
  };
}
